<template>
  <div class="flex-cc"  style="width: 100%" >
    <div>
      <t-button @click="visible = true" >选择门店</t-button>
      <t-button v-if="tableData.length>0" @click="doDel()"  >删除门店</t-button>
    </div>
    <t-table ref="data" border style="width: 100%" :data="tableData"
             @selection-change="selectionChange"
             :header="tableHeader"></t-table>
  </div>
  <el-dialog title="选择商品" v-model="visible" width="1240px">
    <page-request ref="table" url="/api/mgr/business/shop/list" :table-header="tableHeader" :expend="expend" :prop="{type:type}" :hide-op="true"></page-request>
    <template #footer>
          <span class="dialog-footer">
            <el-button @click="visible=false">取消</el-button>
            <el-button type="primary" @click="doSelect()">选择</el-button>
          </span>
    </template>
  </el-dialog>
</template>

<script>

import TButton from "@/components/el/t-button.vue";
import TTable from "@/components/el/t-table.vue";
import PageRequest from "@/components/base/page-request.vue";
import BButton from "@/components/el/b-button.vue";

export default {
  props:{
    type:{
      type:Number,
      default:1
    }
  },
  name: "shop-select",
  components: {BButton, PageRequest, TTable, TButton},
  data() {
    return {
      visible:false,
      tableData:[],
      tableHeader: [
        {type: "selection", label: ""},
        {type: "shop", label: "商家",minWidth:200},
        {label: "状态",renderDraw:row=>{
            return row.status?"禁用":"正常";
          },width: 100},
        {prop: "createTime", label: "注册时间",width: 160}
      ],
      expend:[
        {label: "商家名称",prop: "name"},
        {label: "商家ID",prop: "code"},
        {label: "手机号码",prop: "mobile"},
        {label: "商家状态", prop: "status",type:"dict",dictType:"shopStatus"},
        {label: "登录时间", start: "lastLoginTimeStart", end: "lastLoginTimeEnd", type: "daterange"},
        {label: "注册时间", start: "createTimeStart", end: "createTimeEnd", type: "daterange"}
      ]
    }
  },
  computed:{
    selectIds(){
      return this.tableData.map(item=>item.id);
    }
  },
  mixins: [tableBase],
  methods: {
    selectionChange(list){
      this.selectItems = list;
    },
    doSelect(){
      let list = this.$refs.table.getSelectionRows();
      if(list&&list.length>0){
        this.tableData.pushAll(list.filter(item=>this.selectIds.indexOf(item.id)===-1));
        this.visible =false;
        this.$emit('change',this.tableData);
      }else{
        this.messageError("请勾选要操作的对象");
      }
    },
    doDel(){
      if(this.selectItems&&this.selectItems.length>0){
        this.selectItems.forEach(item=>{
          this.tableData.splice(this.tableData.indexOf(item),1);
        })
        this.$emit('change',this.tableData);
      }else{
        this.messageError("请勾选要操作的对象");
      }
    },
    setTableData(val){
      this.tableData =[];
      val.forEach(row=>{
        row.id = row.goodsId;
        this.tableData.push(row);
      });
      this.$emit('change',this.tableData);
    },
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
